export const LOGGER_TITLES = {
  UPDATE_DEVICE_SUBMIT: 'updateDevice - submitDeviceDetails',
  USER_SIGNALR_HISTORY: 'User SignalR events and api calls history',
  CONNECTOR_HEALTH_FAILED: 'getConnectorInfo: getConnectorHealth failed',
  APP_VERSION_UNSUPPORTED: 'App version unsupported — forced update required',
  APP_VERSION_OUTDATED: 'App version outdated — update recommended',
  ONBOARDING_WIZARD_SUBMIT_FAILED: 'onboardingWizard: submit failed',
  ONBOARDING_HUB_CONNECTED: 'Onboarding - User connected to MembershipOnboarding hub',
  USER_REFRESH_TOKEN: 'User refresh token',
  USER_REFRESH_TOKEN_SUCCESS: 'User refresh token success',
  REFRESH_TOKEN_ERROR: 'Error during refresh token',
  AUTH_INFO_PROFILE_FAILED: 'getAuthInfo: userProfileDetails failed',
  ADD_WEB_ACCOUNT_LOGIN_POPUP_FAILED: 'addWebAccount: loginPopup failed',
  ADD_WEB_ACCOUNT_REINITIALIZE_FAILED: 'addWebAccount: reinitialize failed',
  SWITCH_WEB_ACCOUNT_NOT_FOUND: 'switchWebAccount: account not found',
  SWITCH_WEB_ACCOUNT_TOKEN_FAILED: 'switchWebAccount: token acquisition failed',
  SWITCH_WEB_ACCOUNT_REINITIALIZE_FAILED: 'switchWebAccount: reinitialize failed',
  REMOVE_WEB_ACCOUNT_LOGOUT_FAILED: 'removeWebAccount: logoutPopup failed',
  FINISH_PRODUCTION_OPERATION_FAILED: 'Failed to finish production operation',
  CLOSE_PRODUCTION_OPERATION_FAILED: 'Failed to close production operation',
  LINE_CHART_PERFORMANCE: 'Line chart performance',
  BAR_CHART_PERFORMANCE: 'Bar chart performance',
  QR_SCAN_ERROR: 'QR Scan Error',
  WALLBOARD_OPEN: 'User open Wallboard page',
  TENANT_ON_HOLD: 'Tenant On Hold',
  TENANT_DEACTIVATED: 'Tenant Deactivated',
  AMPLITUDE_INIT_FAILED: 'Amplitude initialization failed',
  ONBOARDING_STARTED: 'Start of the onboarding flow',
  APP_BOOT_AUTHORIZED: 'App boot: authorized state reached',
  APP_BOOT_NAVIGATION_READY: 'App boot: NavigationContainer ready',
  APP_BOOT_MACHINES_PROVIDER_MOUNTED: 'App boot: MachinesProvider mounted',
  APP_BOOT_INITIAL_MACHINES_LOADED: 'App boot: initial getMachines complete',
  UPLOAD_IMAGE_DOCUMENT_SIGNALR_ERROR: 'uploadImageDocumentMessageProducer: SignalR event reported an error',
} as const;
